import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import Carousel from 'react-multi-carousel'
import DiariesCards from './DiariesCards'
import './DiariesSchedule.scss'

const DiariesSchedule = ({ diaries, title }) => {
  if (!diaries) return null

  diaries.sort((a, b) => {
    const now = new Date();
    const dateA = new Date(a.diary.date + " " + a.diary.time);
    const dateB = new Date(b.diary.date + " " + b.diary.time);

    // Si ambos eventos son futuros, ordenarlos de más reciente a más lejano (ASC)
    if (dateA >= now && dateB >= now) {
      return dateA - dateB;
    }
    // Si ambos eventos son pasados, ordenarlos de menos reciente a más reciente (DESC)
    else if (dateA < now && dateB < now) {
      return dateB - dateA;
    }
    // Si uno es futuro y otro es pasado, el futuro debe ir antes
    else {
      return dateA >= now ? -1 : 1;
    }
  });

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1366 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 1366, min: 1024 },
      items: 4
    },
    tablet: {
      breakpoint: { max: 1024, min: 764 },
      items: 3
    },
    mobile: {
      breakpoint: { max: 764, min: 0 },
      items: 1
    }
  }

  return (
    diaries.length && (
      <div className="diaries-container my-5">
        <div className="container mx-auto w-100 pb-4 pt-4">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div className="mb-0 diaries-title">
              {title ? title : 'AGENDA'}{' '}
            </div>
            
            {diaries.some((diary) => new Date(diary.diary.date) >= new Date()) && 
              <Link
                to={'/agenda'}
                className={`btn btn-sm btn-outline-light ml-2 rounded-pill px-3 all-diaries-button`}
              >
                Ver agenda completa
              </Link>
            }
          </div>
          <div id="schedule-component" className="mx-n2">
            <Carousel responsive={responsive}>
              {diaries.map((diary) => {
                if (diary?.diary?.showPosgradoUcc) {
                  return <DiariesCards key={diary?.diary.id} diary={diary?.diary} />
                }
                return null; 

              })}
            </Carousel>
          </div>
        </div>
      </div>
    )
  )
}

export default DiariesSchedule

DiariesSchedule.propTypes = {
  diaries: PropTypes.array,
  title: PropTypes.string
}